// extracted by mini-css-extract-plugin
export default {"button":"StarButton_button__SrbHh"};